import { RegisteredQueryKeys } from './RegisteredQueryKeys';

/**  @deprecated - Please see ~/pages/Courses for an example of how to model queries and invalidation */
export const MutationInvalidationMap = createInvalidationMap({
   'translation-settings': ['translations'],
   'supervisor-rating': [
      'skill-rating',
      'skills-matrix',
      'skills.courses-details-for-team',
      'skills.teams-details-for-course',
      'skills.teams-details-for-guide',
   ],
});

// createInvalidationMap simply ensures the typing of values
//  in MutationInvalidationMap, without defining the type
//  for the keys, so that we can reference the keys later
//  as a static type (typeof keyof MutationInvalidationMap)
function createInvalidationMap<K extends string>(
   invalidationMap: Record<K, (RegisteredQueryKeys | [RegisteredQueryKeys, ...any])[]>
) {
   return invalidationMap;
}
